export const messages = {
    serverError: 'خطا در ارتباط با سرور!\nلطفاً بعداً دوباره تلاش کنید.',
    networkError: 'خطا در اتصال به شبکه!\nلطفاً اتصال خود را بررسی کنید',
    requestFailed: 'درخواست ارسال نشد. لطفاً دوباره تلاش کنید.',
    noActiveCertificate: 'کاربر گواهی فعال ندارد',
}

export const errorTypes = {
    networkError: 'Network Error',
}
